import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from 'seagull';
import styles from './ReferralDashboard.module.scss';
export const Step = (param)=>{
    let { number, text } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.step,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.stepNumber,
                children: number
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: text
            })
        ]
    });
};
